import { useEffect } from 'react';
import { useParams,useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { visualizerActions, uiActions } from '../../store';


import styles from './Visualizer.module.css';

export default function Visualizer() {
    const navigate = useNavigate();
    const urlParams = useParams();
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.visualizer.activeStep);

    // const specifier = useSelector((state) => state.visualizer.specifier);
    // const sel = useSelector((state) => state.visualizer.selString);

    const vizLoading = useSelector((state) => state.ui.vizLoading);

    useEffect(() => {
        document.getElementById("chamViz").addEventListener('ready', function (result) {
            if (activeStep === undefined){
                navigate(`/floorplans`);
            }
            let surfaceData = structuredClone(result.value);
            let saveData = document.getElementById('chamViz').getSaveData();
            dispatch(visualizerActions.setSpecifier(saveData.specifier));
            dispatch(visualizerActions.setSurfaceList(surfaceData));
            dispatch(visualizerActions.setNewSceneLoaded(true));
            dispatch(uiActions.setVizLoading(false))
        });

        document.getElementById("chamViz").addEventListener('surface_apply_done', function (result) {
            let saveData = document.getElementById('chamViz').getSaveData();
            dispatch(visualizerActions.setSelString(saveData.sel));
            dispatch(uiActions.setVizLoading(false))

            // Update sel strings
            dispatch(visualizerActions.setAreaSelString(saveData.sel));
        });

        document.getElementById("chamViz").useMouseovers = false;

        document.getElementById('chamViz').load(urlParams.specifier, urlParams.selString);
    }, [urlParams.specifier, urlParams.selString, dispatch])

    return (
        <div className={`${styles.vizContainer} ${vizLoading?styles.loading:''}`}>
            <div className={styles.loadingScreen}>Loading...</div>
            <cham-viz id="chamViz" spec="" width="1024" active="1"></cham-viz>
            <div className={styles.disclaimer}><p><span>Disclaimer:</span> &nbsp;The images shown are conceptual renderings and may showcase upgrades and/or optional features that are not included in the standard base pricing. Additional costs may apply for these features. Please refer to your New Home Sales Consultant for standard and upgrade information.</p></div>
        </div>
    );
}